import { useCallback } from "react";
import { useSelector } from "react-redux";
import { getFlightShopTrackingProperties } from "@b2bportal/core-flights";
import type { UseInstantTransformEvent } from "@b2bportal/core-tracking";
import type { GridV2OptedOutEvent, GridV2OptedOutRawEvent } from "./events";
import { GridV2EventName } from "./events";

/**
 * grid_v2_opted_out: the opt-out decision with the search it was made from.
 * `grid_version` and `grid_v2_opted_out` themselves are global properties
 * added by AppTrackingProvider, not repeated here.
 */
export const useGridV2OptedOutTransformer: UseInstantTransformEvent<
  GridV2OptedOutRawEvent,
  GridV2OptedOutEvent
> = () => {
  const { trip_type, origin, destination } = useSelector(
    getFlightShopTrackingProperties
  );

  return useCallback(
    (event) => ({
      name: GridV2EventName.grid_v2_opted_out,
      properties: {
        // BFF properties first: the fields the FE owns always win.
        ...event.properties.serverProperties,
        success: event.properties.success,
        failure_reason: event.properties.failure_reason,
        screen: event.properties.screen,
        trip_type,
        origin,
        destination,
      },
    }),
    [trip_type, origin, destination]
  );
};
